import { render, staticRenderFns } from "./sellin.vue?vue&type=template&id=003560e4"
import script from "./sellin.vue?vue&type=script&lang=js"
export * from "./sellin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports